module.exports = __webpack_public_path__ + "img/login.f78cd4d8.webp";